import { useEffect } from "react";
import { useAppSelector } from "../../store";

function RenderedContent({
  render,
  openTranslations,
}: {
  render: string | undefined;
  openTranslations: (keysUsed: string[]) => void;
}) {
  const selectedPath = useAppSelector((state) => state.templates.selectedPath);
  const selectedVersion = useAppSelector((state) => state.templates.selectedVersion);

  async function processRender() {
    if (render === undefined) return;

    const iframe = document.getElementById("rendered-content") as HTMLIFrameElement;

    // Set initial content
    iframe.srcdoc = render;

    // Listen for iframe load event to adjust height
    iframe.onload = () => {
      try {
        const doc = iframe.contentDocument || iframe.contentWindow?.document;
        if (doc) {
          const height = doc.body.scrollHeight;
          iframe.style.height = height + 5 + "px";
        }
      } catch (err) {
        console.warn("Could not resize iframe:", err);
      }
    };
  }

  useEffect(() => {
    if (render === undefined || !selectedPath || !selectedVersion) return;

    const handleClick = (event: any) => {
      if (event.data?.type === "translationClick") {
        openTranslations(event.data.keys.split(/,\s*/) || []);

        const el = document.getElementById("templateAccordion");
        if (el) {
          window.scrollTo({
            top: el.offsetTop + 50,
            behavior: "smooth",
          });
        }
      }
    };

    window.addEventListener("message", handleClick);

    processRender();

    return () => {
      window.removeEventListener("message", handleClick);
    };
  }, [render]);

  return (
    <iframe
      id="rendered-content"
      style={{
        width: "100%",
        height: "500px",
        border: "solid #000000 1px",
        overflow: "hidden" /* hides outer frame scrollbars */,
      }}
    ></iframe>
  );
}

export default RenderedContent;
